module.exports = __webpack_public_path__ + "static/media/3.d5ae7ed8.mp3";